// extracted by mini-css-extract-plugin
export default {"agenciesListStickyHeader":"agenciesListStickyHeader_MGY6P","row":"row_avS3e","header":"header_nk55r","textCenter":"textCenter_yUJHb"};